import { Tooltip, Icon, Box, Typography } from "@mui/material";

interface FileStatusIconProps {
    stateId: number;
}

//Map each file state to icon,color and label
const fileStateIcons: Record<
    number,
    { icon: string; color: "primary" | "error" | "warning" | "success" | "action"; label: string }
> = {
    1: { icon: "cloud_upload", color: "primary", label: "Uploaded" },
    2: { icon: "hourglass_empty", color: "action", label: "Processing" },
    3: { icon: "check_circle", color: "success", label: "Processed" },
    4: { icon: "content_copy", color: "warning", label: "Duplicate Detected" },
    5: { icon: "cancel", color: "error", label: "Upload Failed" },
    6: { icon: "error", color: "error", label: "Processing Failed" },
    7: { icon: "warning", color: "warning", label: "Processed with Errors" },
};

export function FileStatusIcon({ stateId }: FileStatusIconProps) {
    const state = fileStateIcons[stateId];

    return (
        <Box
            display="flex"
            alignItems="center"
            px={1}
            py={0.5}
            borderRadius={1}
            sx={{
                backgroundColor: "#f0f0f0",
            }}
        >
            <Icon fontSize="small" color={state?.color || "disabled"}>
                {state?.icon || "help"}
            </Icon>
            <Typography variant="caption" ml={0.5} color="textSecondary">
                {state?.label}
            </Typography>
        </Box>

    );
}
